import { createAction, props } from "@ngrx/store";
import { PaymentLink } from "../../interfaces";

export const fetchPaymentLinkAction = createAction(
    `[Payment Link] Fetch Payment Link Action`
);

export const fetchPaymentLinkSuccessAction = createAction(
    `[Payment Link] Fetch Payment Link Success Action`,
    props<PaymentLink>()
);

export const fetchPaymentLinkErrorAction = createAction(
    `[Payment Link] Fetch Payment Link Error Action`
);